module.exports = __webpack_public_path__ + "img/20190530161248475.0bccd773.png";